import { Reveal } from '@/components/motion/Reveal'
import { SplitText } from '@/components/motion/SplitText'
import { useSite } from '@/app/site-context'
import { interpolate } from '@/i18n'
import { reviewNoteFor } from '@/i18n/review-notes'
import { siteConfig } from '@/lib/site-config'

interface PrivacyPageProps {
  onNavigate: (href: string) => void
}

export function PrivacyPage({ onNavigate }: PrivacyPageProps) {
  const { dictionary, pathFor, locale } = useSite()
  const { privacy } = dictionary
  const reviewNote = reviewNoteFor(locale)
  const home = pathFor('home')
  const controller = `${siteConfig.legalName} (MBO ${siteConfig.register.mbo})`

  return (
    <section className="prose section" aria-labelledby="privacy-title">
      <h1 className="prose__title" id="privacy-title">
        <SplitText text={privacy.title} stagger={40} />
      </h1>
      <p className="prose__meta">
        {privacy.lastUpdatedLabel}:{' '}
        <time dateTime={privacy.lastUpdated}>{privacy.lastUpdated}</time>
      </p>
      {reviewNote === undefined ? null : (
        <p className="prose__meta policy__languages">{reviewNote.legal}</p>
      )}
      <Reveal variant="rise">
        <p className="prose__lede">{privacy.intro}</p>
      </Reveal>

      {privacy.sections.map((section, index) => (
        <Reveal variant="rise" delay={index * 60} key={section.heading}>
          <h2 className="prose__heading">{section.heading}</h2>
          {section.paragraphs.map((paragraph) => (
            <p className="prose__paragraph" key={paragraph.slice(0, 32)}>
              {interpolate(paragraph, { controller, email: siteConfig.email })}
            </p>
          ))}
        </Reveal>
      ))}

      <a
        className="button button--ghost prose__back"
        href={home}
        onClick={(event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
          event.preventDefault()
          onNavigate(home)
        }}
      >
        {privacy.backHome}
      </a>
    </section>
  )
}
